/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu June 15 2021 14:30:00 PM
 *
 *******************************************************/
//flow
import React from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Banner, TextStyle } from '@shopify/polaris';
import { getShop } from 'src/helpers';

type Props = {
  usingThemeUpgrade: boolean,
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

const NotifPublishThemeV2: React.FC<ComposedProps> = ({
  usingThemeUpgrade = false,
  emailSupport,
  i18n
}) => {
  const title = usingThemeUpgrade
    ? i18n.translate('AdminHTML.Dashboard.NotifPublishThemeV2.titleThemeUpgrade', {
        nt_theme_name: '[Boost] Copy of your theme - latest app version'
      })
    : i18n.translate('AdminHTML.Dashboard.NotifPublishThemeV2.titleThemeSetup');

  const handleAction = () => {
    const shop = getShop();

    window.top.location.href = `https://${shop}/admin/themes`;
  };

  return (
    <Banner
      status="warning"
      title={title}
      action={{
        content: i18n.translate('AdminHTML.Dashboard.NotifPublishThemeV2.actionLabel'),
        onAction: handleAction
      }}>
      <p>
        {i18n.translate('AdminHTML.Dashboard.NotifPublishThemeV2.content1', {
          t1: (
            <TextStyle variation="strong">
              {i18n.translate('AdminHTML.Dashboard.NotifPublishThemeV2.content1_t1')}
            </TextStyle>
          ),
          t2: (
            <TextStyle variation="strong">
              {i18n.translate('AdminHTML.Dashboard.NotifPublishThemeV2.content1_t2')}
            </TextStyle>
          ),
          t3: (
            <TextStyle variation="strong">
              {i18n.translate('AdminHTML.Dashboard.NotifPublishThemeV2.content1_t3')}
            </TextStyle>
          )
        })}
      </p>
      {!usingThemeUpgrade && (
        <>
          <br />
          <p>
            {i18n.translate('AdminHTML.Dashboard.NotifPublishThemeV2.content2', {
              nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
            })}
          </p>
        </>
      )}
    </Banner>
  );
};

export default withI18n()(NotifPublishThemeV2);
